import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TemplatesPreview } from '@dev/ee-modules';
import { Portal } from '@material-ui/core';

import { SetToastPortalWrapper } from '@/store/toast/actions';
import { getAutomationStore, ClearPreviewTemplate } from '@/store/automations/actions';
import { ApplicationState } from '@/store';
import useMobile from '@/services/hooks/useMobile';

export const Preview = (): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(SetToastPortalWrapper(true));

        return function cleanup() {
            dispatch(SetToastPortalWrapper(false));
        };
    }, []);

    const automations = useSelector(getAutomationStore);
    const browser = useSelector((state: ApplicationState) => state.browser);
    const { previewTemplate } = automations;
    const name = previewTemplate.name;
    const currentHtml = previewTemplate.html || 'Loading';
    const isMobile = useMobile();

    return (
        <Portal>
            <TemplatesPreview
                open={true}
                browser={browser}
                isDrawerMenuFolded={false}
                templateList={null}
                templateHtml={currentHtml}
                templateName={name}
                isMobile={isMobile}
                onCloseClick={() => {
                    dispatch(ClearPreviewTemplate());
                }}
            />
        </Portal>
    );
};
